import React from "react";
import VlogList from "../VlogList/VlogList";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const VlogListTechnologyTopics = () => {
  const title = "נושאים טכנולוגיים";
  const description = `ברוכים הבאים למאגר הידע שלי על נושאים טכנולוגיים! כאן תמצאו אוסף עשיר של וולוגים שמסבירים באופן מעמיק את כל מה שקשור בנושאים טכנולוגיים שונים. המאגר נבנה במיוחד כדי לעזור לכם להבין את העקרונות, המושגים והטכנולוגיות שמאחורי כל נושא, ולהעמיק את הידע שלכם בתחום. כל וולוג מציע הסברים ברורים, דוגמאות פרקטיות, ונותן כלים חשובים להתמודד עם בעיות טכנולוגיות בצורה טובה יותר. המטרה היא לא רק להעשיר את הידע שלכם, אלא גם להפוך אתכם למומחים בתחומים השונים ולהתמודד עם אתגרים טכנולוגיים בצורה יעילה ומתקדמת.`;

  const vlogs = [
    {
      topic: "API",
      vlogs: [
        { id: "TechnologyTopicsJson/API/Vlog1", name: "מה זה API?" },
        {
          id: "TechnologyTopicsJson/API/Vlog2",
          name: "איך APIs עובדים?",
        },
        { id: "TechnologyTopicsJson/API/Vlog3", name: "סוגי APIs" },
        {
          id: "TechnologyTopicsJson/API/Vlog4",
          name: "הבנת Authentication ב-APIs",
        },
        {
          id: "TechnologyTopicsJson/API/Vlog5",
          name: "ניהול שגיאות ולוגים ב-API",
        },
        {
          id: "TechnologyTopicsJson/API/Vlog6",
          name: "איך לגרום ל-API להגיב מהר יותר",
        },
        {
          id: "TechnologyTopicsJson/API/Vlog7",
          name: "מה זה JSON ולמה הוא כל כך חשוב ב-APIs?",
        },
        {
          id: "TechnologyTopicsJson/API/Vlog8",
          name: "מה זה Webhooks ואיך הם עובדים?",
        },
        {
          id: "TechnologyTopicsJson/API/Vlog9",
          name: "תכנון ופיתוח API: איך יוצרים API נכון?",
        },
        {
          id: "TechnologyTopicsJson/API/Vlog10",
          name: "איך מוודאים שה-API עובד כמו שצריך?",
        },
      ],
    },
    {
      topic: "API Gateway",
      vlogs: [
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog1",
          name: "מה זה API Gateway?",
        },
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog2",
          name: "תפקידים ותכונות עיקריות של API Gateway",
        },
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog3",
          name: "למה להשתמש ב-API Gateway?",
        },
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog4",
          name: "תכנון ואדריכלות API Gateway",
        },
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog5",
          name: "שימושים במיקרו-שירותים (Microservices)",
        },
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog6",
          name: "אבטחה וניטור (Security and Monitoring)",
        },
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog7",
          name: "תפקיד ה-API Gateway בניהול בקשות ותגובות",
        },
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog8",
          name: "אתגרים ונקודות תורפה ב-API Gateway",
        },
        {
          id: "TechnologyTopicsJson/API Gateway/Vlog9",
          name: "שימושי API Gateway כחלק מ-System Design",
        },
      ],
    },
    {
      topic: "Load Balancer",
      vlogs: [
        {
          id: "TechnologyTopicsJson/Load Balancer/Vlog1",
          name: "מה זה Load Balancer?",
        },
        {
          id: "TechnologyTopicsJson/Load Balancer/Vlog2",
          name: "סוגי Load Balancer ואיך הם עובדים?",
        },
        {
          id: "TechnologyTopicsJson/Load Balancer/Vlog3",
          name: "מספר אלגוריתמים שמנחים את ה-Load Balancer",
        },
        {
          id: "TechnologyTopicsJson/Load Balancer/Vlog4",
          name: "יתרונות וחסרונות של Load Balancer",
        },
        {
          id: "TechnologyTopicsJson/Load Balancer/Vlog5",
          name: "Load Balancer במערכות מודרניות",
        },
        {
          id: "TechnologyTopicsJson/Load Balancer/Vlog6",
          name: "טעויות נפוצות בשימוש ב-Load Balancer ואיך להימנע מהן",
        },
        {
          id: "TechnologyTopicsJson/Load Balancer/Vlog7",
          name: "דוגמאות מעשיות ותיאורי מקרה (Case Studies)",
        },
        {
          id: "TechnologyTopicsJson/Load Balancer/Vlog8",
          name: "שאלות ותשובות על Load Balancer",
        },
      ],
    },
  ];

  return (
    <>
      <VlogList title={title} description={description} vlogs={vlogs} />
    </>
  );
};

export default VlogListTechnologyTopics;
